<script setup>
import Tooltip from '@/components/Atoms/Tooltip.vue'

defineProps({
	email: {
		type: String,
		default: '',
	},
	active: {
		type: Boolean,
		default: true,
	},
	wrapperClass: {
		type: String,
		default: 'inline',
	},
})
</script>

<template>
	<Tooltip :active="active" :wrapper-class="wrapperClass">
		<slot />
		<template #content>
			<span class="text-dark-8 text-small">
				You don't have permission. Contact the team owner at
				<a class="text-dark-8 text-small" :href="'mailto:' + email">{{ email }}</a>
				to gain access.
			</span>
		</template>
	</Tooltip>
</template>
